var map = {
	"./1.png": 8909,
	"./2.png": 1973,
	"./3.png": 583,
	"./4.png": 695,
	"./5.png": 1525,
	"./6.png": 161,
	"./7.png": 8265,
	"./8.png": 8480,
	"./9.png": 2674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2849;